import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Response } from "@angular/http";
import { DropdownValue } from '../shared/dropdown.model';
import { PublisherSelectionComponent } from '../shared/publisher-selection.component';
import { FilterItemsService } from '../shared/filter-items.service';
import { PublisherCampaignAllocation } from './campaign.model';
import { CampaignsService } from './campaigns.service';
import { FieldValidatorService } from '../shared/field-validator-service';
import { FormHelperService } from "../core/services/form-helper.service";
import { consts } from "../shared/consts";
import { DateHelperService } from '../core/services/date-helper.service';
import { ObjectFactoryService } from '../core/services/object-factory.service';

@Component({
    selector: 'publisher-allocation-modal',
    moduleId: module.id,
    templateUrl: 'publisher-allocation-modal.component.html'
})
export class PublisherAllocationComponent implements OnInit {
    publisherAllocationFrom: FormGroup;
    headerText: string = "Create Publisher Parameter";
    publisherSelectionText: string;
    startDate: Date;
    endDate: Date;
    private publisherId: number = 0;
    publisherAllocationId: number;
    private campaignId: number;
    minDate: Date = new Date();
    maxDate: Date;
    isLoading: boolean = false;
    dateError: string;
    campaignIsFallback: boolean = false;

    @ViewChild("publisherSelector") publisherSelectionComponent: PublisherSelectionComponent;

    @Output()
    public publisherAllocationChanged: EventEmitter<PublisherCampaignAllocation> = new EventEmitter<PublisherCampaignAllocation>();;

    @Output()
    public publisherAllocationCreated: EventEmitter<PublisherCampaignAllocation> = new EventEmitter<PublisherCampaignAllocation>();;

    constructor(
        private filterItemsService: FilterItemsService,
        private formBuilder: FormBuilder,
        private campaignsService: CampaignsService,
        private fieldValidatorService: FieldValidatorService,
        private formHelperService: FormHelperService,
        private dateHelper: DateHelperService,
        private el: ElementRef,
        private factoryService: ObjectFactoryService) {
    }

    ngOnInit() {
        this.publisherAllocationFrom = this.formBuilder.group({
            publisherCpeField: ['', [Validators.required, this.fieldValidatorService.isPositiveNumber]],
            totalAllocatedViewsField: ['', [Validators.required, this.fieldValidatorService.isPositiveInteger]],
            totalAllocatedViewsPerDayField: ['', [Validators.required, this.fieldValidatorService.isPositiveInteger]],
            totalRequestsPerUserPerDayField: ['', [Validators.required, this.fieldValidatorService.isPositiveInteger]],
            isAvailableField: ['', []]
        });
    }

    onSaveChanges(event: any) {
        if (this.dateHelper.utcDateOnly(this.startDate) > this.dateHelper.utcDateOnly(this.endDate)) {
            this.dateError = consts.StartDateGreaterThanEndDateText;
            return;
        }
        this.dateError = '';
        if (!this.publisherAllocationFrom.valid) { return; };
        let publisherCampaignAllocation = new PublisherCampaignAllocation();
        if (this.publisherAllocationId === 0) {
            publisherCampaignAllocation = this.factoryService.createPublisherAllocation(0, this.campaignId, this.publisherId,
                new Date(Date.UTC(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate())),
                new Date(Date.UTC(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate())),
                !this.publisherAllocationFrom.value.isAvailableField ? false : true,
                this.campaignIsFallback == false ? this.publisherAllocationFrom.value.publisherCpeField : consts.DefaultPublisherCpe,
                this.campaignIsFallback == false ? this.publisherAllocationFrom.value.totalAllocatedViewsField : consts.DefaultPublisherTotalAllocatedViews,
                this.campaignIsFallback == false ? this.publisherAllocationFrom.value.totalAllocatedViewsPerDayField : consts.DefaultPublisherTotalAllocatedViewsPerDay,
                this.campaignIsFallback == false ? this.publisherAllocationFrom.value.totalRequestsPerUserPerDayField : consts.DefaultPublisherTotalAllocatedViewsPerUser
            );

            this.isLoading = true;
            let result = this.campaignsService.createPublisherAllocation(publisherCampaignAllocation).subscribe(response => {
                this.publisherAllocationCreated.emit(response.json());
                $('#publisherAllocationModal').modal('hide');
            }, () => { }, () => { this.isLoading = false; });
        }
        else {
            publisherCampaignAllocation = this.factoryService.createPublisherAllocation(this.publisherAllocationId, this.campaignId, this.publisherId,
                new Date(Date.UTC(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate())),
                new Date(Date.UTC(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate())),
                !this.publisherAllocationFrom.value.isAvailableField ? false : true,
                this.publisherAllocationFrom.value.publisherCpeField,
                this.publisherAllocationFrom.value.totalAllocatedViewsField,
                this.publisherAllocationFrom.value.totalAllocatedViewsPerDayField,
                this.publisherAllocationFrom.value.totalRequestsPerUserPerDayField
            );

            this.isLoading = true;
            let result = this.campaignsService.updatePublisherAllocation(publisherCampaignAllocation).subscribe(response => {
                let publisherCampaignAllocation = response.json();
                publisherCampaignAllocation.publisherName = this.publisherSelectionText;
                this.publisherAllocationChanged.emit(publisherCampaignAllocation);
                $('#publisherAllocationModal').modal('hide');
            }, () => { }, () => { this.isLoading = false; });
        }
    }

    onPublisherValueChanged(item) {
        this.publisherId = item.value;
    }

    showCreatePublisherAllocation(campaignId: number, providerId: number, countryId: number, isMediation: boolean, startDate, endDate, isFallback: boolean) {
        this.isLoading = false;
        this.headerText = "Create Publisher Parameter";
        this.publisherAllocationFrom.reset();
        this.campaignIsFallback = isFallback;
        this.startDate = new Date();
        this.endDate = new Date();
        this.publisherAllocationId = 0;
        this.campaignId = campaignId;
        this.publisherAllocationFrom.controls["totalRequestsPerUserPerDayField"].setValue(1000);
        if (this.campaignIsFallback == true) {
            this.bindPublisherAllocationForm(consts.DefaultPublisherCpe, false,
                consts.DefaultPublisherTotalAllocatedViews, consts.DefaultPublisherTotalAllocatedViewsPerDay,
                consts.DefaultPublisherTotalAllocatedViewsPerUser);
        }
        if (isMediation) {
            this.campaignsService.getAllowedPublisherIdsByProviderAndCountry(providerId, countryId).subscribe(response => {
                let items = response.json();
                this.publisherSelectionComponent.loadItems(items);
                let selectedItem = this.publisherSelectionComponent.setFirstItem();
                if (selectedItem)
                    this.publisherId = selectedItem.value;
            });
        }
        else {
            this.publisherSelectionComponent.loadItems(null);
            let selectedItem = this.publisherSelectionComponent.setFirstItem();
            if (selectedItem)
                this.publisherId = selectedItem.value;
        }
        if (startDate)
            this.minDate = startDate;
        if (endDate)
            this.maxDate = endDate;
        $('#publisherAllocationModal').modal('show');
    }

    showEditPublisherAllocation(event, item, startDate, endDate, isFallback) {
        this.isLoading = false;
        this.campaignIsFallback = isFallback;
        event.preventDefault();
        event.stopPropagation();
        this.headerText = "Edit Publisher Parameter";
        this.bindPublisherAllocationForm(item.publisherCpe, item.isAvailable,
            item.totalAllocatedViews, item.totalAllocatedViewsPerDay, item.totalRequestsPerUserPerDay);

        this.startDate = new Date(item.startUtc);
        this.endDate = new Date(item.endUtc);
        if (startDate)
            this.minDate = startDate;
        if (endDate)
            this.maxDate = endDate;
        this.publisherAllocationId = item.id;
        this.campaignId = item.campaignId;

        this.publisherSelectionComponent.loadItems(null);
        this.publisherSelectionComponent.setCurrentSelection(item.publisherId);
        this.publisherId = item.publisherId;
        let selectedItem = this.publisherSelectionComponent.getItem(this.publisherId);
        if (selectedItem)
            this.publisherSelectionText = selectedItem.label;
        else this.publisherSelectionText = '';

        $('#publisherAllocationModal').modal('show');
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.publisherAllocationFrom, controlName, validator)
    }

    public onDateClicked(event) {
        let ng2datePicker = this.el.nativeElement.querySelectorAll("ng2-datetime-picker[draggable='true']");
        $(ng2datePicker).attr('draggable', 'false');
    }

    private bindPublisherAllocationForm(publisherCpe: number, isAvailable: boolean,
        totalAllocatedViews: number, totalAllocatedViewsPerDay: number, totalRequestsPerUserPerDay: number) {
        this.publisherAllocationFrom.controls["totalRequestsPerUserPerDayField"].setValue(totalRequestsPerUserPerDay);
        this.publisherAllocationFrom.controls["publisherCpeField"].setValue(publisherCpe);
        this.publisherAllocationFrom.controls["totalAllocatedViewsField"].setValue(totalAllocatedViews);
        this.publisherAllocationFrom.controls["totalAllocatedViewsPerDayField"].setValue(totalAllocatedViewsPerDay);
        this.publisherAllocationFrom.controls["isAvailableField"].setValue(isAvailable);
    }
}


// WEBPACK FOOTER //
// ./src/app/campaigns/publisher-allocation-modal.component.ts